module.exports = __webpack_public_path__ + "static/media/gcourse1.38de434c.png";